/*
* Popper.JS required for bootstrap
*/
import 'popper.js';


// WEBPACK FOOTER //
// ./scripts/autoload/_popper.js